import { render, staticRenderFns } from "./OperaMultifileWindow.vue?vue&type=template&id=e5db87b2&"
import script from "./OperaMultifileWindow.vue?vue&type=script&lang=js&"
export * from "./OperaMultifileWindow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports